import { SET_GAME_IS_ACTIVE, SET_CHECK_GAME_IS_ACTIVE, SET_CHANGE_GAME_IS_ACTIVE } from "@actions/actionTypes";

export default function gameIsActiveReducer(state = true, action) {
    switch (action.type) {
        case SET_GAME_IS_ACTIVE:
            return action.isActive;
        case SET_CHECK_GAME_IS_ACTIVE:
            return action.isActive;
        case SET_CHANGE_GAME_IS_ACTIVE:
            return action.isActive;
        default:
            return state;
    }
}
